<form action="auth-dialog_submit" method="get" accept-charset="utf-8">
  <h1>{{ 'Protected collection' | translate }}</h1>

  <p>
    {{ 'This collection is protected by a password.' | translate }}
  </p>
  <p>
    {{ 'Type in the password to load this collection.' | translate }}
  </p>

  <k-input
    [label]="'Password' | translate"
    type="password"
    (valueChanged)="password = $event.value"
  />

  <k-button-row>
    <k-button full-width type="solid-primary" (click)="check()">{{ 'Check' | translate }}</k-button>
  </k-button-row>
</form>
